module.exports = __webpack_public_path__ + "img/logo-ans.aba239e4.png";